import {
  mergeStyleSets,
  TooltipHost,
  TooltipOverflowMode,
} from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config/routes";

const classes = mergeStyleSets({
  fleetName: {
    cursor: "pointer",
    fontWeight: "bold",
  },
  cancelledFleet: {
    cursor: "pointer",
    fontWeight: "bold",
    textDecoration: "line-through",
  },
});

type Props = {
  fleetName: string;
  fleetId: number;
  isCancelled?: boolean;
};

const FleetName = ({ fleetName, fleetId, isCancelled }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToFleet = () => {
    navigate(routes.fleet.getPath(fleetId));
  };

  const tooltipContent = isCancelled
    ? `${fleetName} - ${t("bfm.cancelledFleet.tooltip")}`
    : fleetName;

  return (
    <TooltipHost
      content={tooltipContent}
      overflowMode={isCancelled ? undefined : TooltipOverflowMode.Parent}
    >
      <span
        className={isCancelled ? classes.cancelledFleet : classes.fleetName}
        onClick={goToFleet}
      >
        {fleetName}
      </span>
    </TooltipHost>
  );
};

export default FleetName;
